import React, { useEffect, useState } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import { getUserEnrolledCourses } from "../../../services/operations/ProfileAPI";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function EnrolledCourses(props) {
  const { token } = useSelector((state) => state.auth);

  const [enrolledCourses, setEnrolledCourses] = useState(null);

  const navigate = useNavigate();

  const getEnrolledCourses = async () => {
    try {
      const response = await getUserEnrolledCourses(token);
      setEnrolledCourses(response);
    } catch (e) {
      console.log("Error while fetching enrolled courses");
    }
  };

  useEffect(() => {
    getEnrolledCourses();
  }, []);

  return (
    <div>
      <div className="text-richblack-25">
        <div className="text-3xl">Enrolled Courses</div>
        <div className="mt-5">
          {!enrolledCourses ? (
            <div className="spinner flex justify-center items-center"></div>
          ) : !enrolledCourses.length ? (
            <p>You have not enrolled in any course yet</p>
          ) : (
            <div>
              <div>
                <div className="flex rounded-t-lg bg-richblack-500 ">
                  <p className="w-[45%] px-5 py-3">Course Name</p>
                  <p className="w-1/4 px-2 py-3">Duration</p>
                  <p className="flex-1 px-2 py-3">Progress</p>
                </div>
              </div>
              {/* cards */}
              {enrolledCourses.map((course, index, arr) => {
                return (
                  <div
                    key={index}
                    className={`flex items-center border border-richblack-700 ${
                      index === arr.length - 1 ? "rounded-b-lg" : "rounded-none"
                    }`}>
                    <div
                      // className="flex w-[100%] cursor-pointer items-center gap-4 px-5 py-3"
                      className="flex w-[100%] cursor-pointer items-center gap-4 px-5 py-3"
                      onClick={() => {
                        navigate(
                          `/view-course/${course?._id}/section/${course.courseContent[0]?._id}/sub-section/${course.courseContent?.[0]?.subSection?.[0]?._id}`
                        );
                      }}>
                      <img
                        // width={`250px`}
                        src={course.thumbnail}
                        alt={`course-${course.courseName}`}
                        // className="rounded-md"
                        className="h-[200px] max-[450px]:h-[75px] rounded-lg object-cover"
                      />
                      <div className="flex flex-col max-[450px]:-translate-x-1 translate-x-16 items-center justify-center">
                        <p>{course.courseName}</p>
                        <p>
                          {course.courseDescription.length > 50
                            ? course.courseDescription.slice(0, 50)
                            : course.courseDescription}
                        </p>
                      </div>
                    </div>
                    <div className="w-1/10 px-2 py-3">
                      {/* duration */}
                      {course?.total}
                    </div>
                    <div className="flex w-1/5 flex-col max-[450px]:-translate-x-8  -translate-x-28 gap-2 px-2 py-3">
                      <p>Progress: {course.progressPercentage || 0}</p>
                      <ProgressBar
                        completed={course.progressPercentage || 0}
                        height="8px"
                        isLabelVisible={false}
                        customLabel="Not there yet"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EnrolledCourses;
